import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row m-0 gy-2" }
const _hoisted_2 = ["disabled", "onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (val, index) => {
      return (_openBlock(), _createElementBlock("button", {
        disabled: _ctx.variants !== null && !_ctx.variants[index],
        key: index,
        class: _normalizeClass({'col-12':1, 'pretty_button':1,'active': this.modelValue.includes(index)}),
        onClick: ($event: any) => (_ctx.toggleValue(index))
      }, [
        _createTextVNode(_toDisplayString(val) + " ", 1),
        _hoisted_3,
        (_ctx.variants[index])
          ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.variants[index]) + " " + _toDisplayString(_ctx.declOfNum(_ctx.variants[index],["отель","отеля","отелей"])), 1))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}